import { format, parseISO } from "date-fns";

import {
  Container,
  Content,
  Description,
  Timeline,
  History,
  Title,
  ItemHistory,
} from "./styles";
import { ITask } from "../../modules/tasks/interface";
import { useTranslate } from "../../hooks/useTranslate";

const CardHistoryTask = ({ photo, description, historic }: ITask) => {
  const { translate } = useTranslate();

  return (
    <Container>
      <Content>
        <img src={photo} alt={description} />
        <Description>
          <p>{description}</p>
        </Description>
      </Content>
      <History>
        <Title>{translate("tasks.title_history")}</Title>
        <Timeline>
          {historic.map((item) => (
            <Timeline.Item key={item.title} color="gray">
              <ItemHistory>
                <div>
                  <p>{item.title}</p>
                  <span>{format(parseISO(item.date), "dd MMM yyyy")}</span>
                </div>
                <span>{item.description}</span>
              </ItemHistory>
            </Timeline.Item>
          ))}
          <Timeline.Item></Timeline.Item>
        </Timeline>
      </History>
    </Container>
  );
};

export { CardHistoryTask };
